module.exports = __webpack_public_path__ + "static/media/photo_018.ee820cd1.JPG";